import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const transparent = isHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? 'bg-transparent'
          : 'bg-white/90 dark:bg-[#3b5268]/95 backdrop-blur-xl shadow-sm'
      }`}
    >
      <div className="max-w-[1100px] mx-auto px-6 py-2 flex items-center justify-center">
        <div className="flex items-center gap-10">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer mr-4">
            <div className="w-[120px] h-[120px] flex items-center justify-center -my-7">
              <img
                src="https://public.readdy.ai/ai/img_res/09855a0a-ea1e-45c4-a8bf-6d5918c6c158.png"
                alt="Sapentis AI Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </Link>

          <Link
            to="/solutions"
            className={`text-xs font-normal tracking-tight transition-colors hover:text-[#0E1A2B] dark:hover:text-white whitespace-nowrap ${
              transparent ? 'text-white/90' : 'text-[#5C6675] dark:text-[#8899aa]'
            } ${location.pathname === '/solutions' ? '!text-[#0E1A2B] dark:!text-white' : ''}`}
          >
            Solutions
          </Link>
          <a
            href={isHome ? '#industries' : '/#industries'}
            className={`text-xs font-normal tracking-tight transition-colors hover:text-[#0E1A2B] dark:hover:text-white whitespace-nowrap ${
              transparent ? 'text-white/90' : 'text-[#5C6675] dark:text-[#8899aa]'
            }`}
          >
            Industries
          </a>
          <Link
            to="/about"
            className={`text-xs font-normal tracking-tight transition-colors hover:text-[#0E1A2B] dark:hover:text-white whitespace-nowrap ${
              transparent ? 'text-white/90' : 'text-[#5C6675] dark:text-[#8899aa]'
            } ${location.pathname === '/about' ? '!text-[#0E1A2B] dark:!text-white' : ''}`}
          >
            About
          </Link>
          <a
            href={isHome ? '#approach' : '/#approach'}
            className={`text-xs font-normal tracking-tight transition-colors hover:text-[#0E1A2B] dark:hover:text-white whitespace-nowrap ${
              transparent ? 'text-white/90' : 'text-[#5C6675] dark:text-[#8899aa]'
            }`}
          >
            Approach
          </a>

          {/* Day / Night Toggle */}
          <button
            onClick={toggleTheme}
            aria-label="Toggle day/night mode"
            className={`w-8 h-8 flex items-center justify-center rounded-full transition-all cursor-pointer ${
              transparent
                ? 'text-white/90 hover:text-white hover:bg-white/10'
                : 'text-[#5C6675] dark:text-[#8899aa] hover:text-[#0E1A2B] dark:hover:text-white hover:bg-[#0E1A2B]/5 dark:hover:bg-white/10'
            }`}
          >
            {theme === 'light' ? (
              <i className="ri-moon-line text-base"></i>
            ) : (
              <i className="ri-sun-line text-base"></i>
            )}
          </button>

          <Link
            to="/solutions#audit"
            className="bg-[#0E1A2B] dark:bg-[#28D7C6] text-white dark:text-[#0E1A2B] px-5 py-1.5 rounded-full text-xs font-normal hover:bg-[#1a2d47] dark:hover:bg-[#20c4b5] transition-all whitespace-nowrap cursor-pointer"
          >
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
}
